import React from 'react';
import { FileText, Download, Upload, Save } from 'lucide-react';
import API_URL from '../../../../config';

const FileUploadInput = ({ label, currentFileUrl, fileState, setFileState, id, toast }) => {
    return (
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3 w-full">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                    <FileText className="w-5 h-5 text-blue-600" />
                </div>
                <div className="flex-1">
                    <h4 className="text-sm font-semibold text-slate-800">{label}</h4>
                    <div className="flex items-center gap-2 mt-1">
                        {currentFileUrl ? (
                            <a 
                                href={`${API_URL}${currentFileUrl}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1 font-medium bg-blue-50 px-2 py-1 rounded-md"
                            >
                                <Download className="w-3 h-3" /> Ver / Descargar actual
                            </a>
                        ) : (
                            <span className="text-xs text-slate-500 italic">Ningún documento subido</span>
                        )}
                    </div>
                </div>
            </div>
            
            <div className="flex-shrink-0 w-full md:w-auto">
                <input 
                    type="file" 
                    id={id} 
                    className="hidden" 
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                            if (file.size > 10 * 1024 * 1024) {
                                toast.error('El archivo no debe superar los 10MB');
                                e.target.value = null;
                                return;
                            }
                            setFileState(file);
                        }
                    }}
                />
                <label 
                    htmlFor={id} 
                    className={`w-full md:w-auto flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer border ${
                        fileState 
                        ? 'bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100' 
                        : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50 shadow-sm'
                    }`}
                >
                    {fileState ? (
                        <>
                            <Save className="w-4 h-4" />
                            {fileState.name}
                        </>
                    ) : (
                        <>
                            <Upload className="w-4 h-4" />
                            Subir {label}
                        </>
                    )}
                </label>
            </div>
        </div>
    );
};

const DocumentosLegales = ({ junta, files, setFiles, toast }) => {
    return (
        <div className="bg-white rounded-2xl p-5 md:p-6 shadow-sm border border-slate-100">
            <div className="flex items-center gap-2 mb-4 border-b border-slate-100 pb-3">
                <FileText className="w-4 h-4 text-blue-600" />
                <h2 className="text-base font-semibold text-slate-800">Documentos Legales e Institucionales</h2>
            </div>
            <p className="text-xs text-slate-500 mb-4">Estos documentos se mantendrán de forma segura en el servidor. Solo se permiten formatos PDF o Word (Máx 10MB).</p>

            <div className="space-y-3">
                <FileUploadInput 
                    label="Reglamento Interno" 
                    currentFileUrl={junta?.configuracion?.archivo_reglamento}
                    fileState={files.reglamentoFile}
                    setFileState={setFiles.setReglamentoFile}
                    id="upload-reglamento"
                    toast={toast}
                />
                
                <FileUploadInput 
                    label="Nómina de Socios / Directorio" 
                    currentFileUrl={junta?.configuracion?.archivo_nomina}
                    fileState={files.nominaFile}
                    setFileState={setFiles.setNominaFile}
                    id="upload-nomina"
                    toast={toast}
                />
                
                <FileUploadInput 
                    label="Estatutos Aprobados" 
                    currentFileUrl={junta?.configuracion?.archivo_estatuto}
                    fileState={files.estatutoFile}
                    setFileState={setFiles.setEstatutoFile}
                    id="upload-estatuto"
                    toast={toast}
                />
            </div>
        </div>
    );
};

export default DocumentosLegales;
